import { render, staticRenderFns } from "./PhosphorusRequirementDetails.vue?vue&type=template&id=6d5508b0&scoped=true&"
import script from "./PhosphorusRequirementDetails.vue?vue&type=script&lang=js&"
export * from "./PhosphorusRequirementDetails.vue?vue&type=script&lang=js&"
import style0 from "./PhosphorusRequirementDetails.vue?vue&type=style&index=0&id=6d5508b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d5508b0",
  null
  
)

export default component.exports